query UserApprovalSearchFilterTotals(
  $isQueuedSearch: Boolean
  $searchRequest: SearchRequestInput
  $filterBusinessUnitId: UUID
  $filterStatusTypeId: Int
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
  $filterDepartmentId: UUID
) {
  userApprovalSearchFilterTotals(
    filterBusinessUnitId: $filterBusinessUnitId
    filterDepartmentId: $filterDepartmentId
    filterStatusTypeId: $filterStatusTypeId
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    searchRequest: $searchRequest
    isQueuedSearch: $isQueuedSearch
  ) {
    totalCount1
    totalAmount1
  }
}
